module.exports = __webpack_public_path__ + "static/media/UB_logotyp_gra_RGB.41bb6ae4.png";